module.exports = __webpack_public_path__ + "img/SUP1.06e35d13.jpg";